import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["empty", "filter", "item", "query", "resultCount"]
  static values = { state: { type: String, default: "all" } }

  connect() {
    this.apply()
    this.updateFilters()
  }

  setState(event) {
    this.stateValue = event.params.state
    this.apply()
    this.updateFilters()
  }

  apply() {
    const query = this.queryTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const checkbox = item.querySelector("input[type='checkbox']")
      const matchesQuery = item.dataset.searchValue.includes(query)
      const matchesState =
        this.stateValue === "all" ||
        (this.stateValue === "enabled" && checkbox.checked) ||
        (this.stateValue === "disabled" && !checkbox.checked)
      const visible = matchesQuery && matchesState

      item.hidden = !visible
      if (visible) {
        visibleCount += 1
      }
    })

    this.resultCountTarget.textContent = `${visibleCount} ${visibleCount === 1 ? "flag" : "flags"}`
    this.emptyTarget.hidden = visibleCount > 0
  }

  updateFilters() {
    this.filterTargets.forEach((filter) => {
      const active = filter.dataset.state === this.stateValue
      filter.classList.toggle("c-button--white-inactive", !active)
      filter.setAttribute("aria-pressed", active.toString())
    })
  }
}
